<div class="d-flex align-items-center m-2">
    <div class="date-div">
        <label class="form-label" for="fromDate">From:</label>

        <div class="position-relative" (click)="fromDateInput.showPicker()">
            <input type="text" class="form-control form-control-sm" [value]="displayStartDate" readonly />
            <input type="date" [(ngModel)]="startDate" [max]="disabledDates" (change)="handleSelectedCustomDate()"
                #fromDateInput class="visually-hidden-date" />
            <span class="calendar-icon input-icon">
                <app-common-icon [faIcon]="faCalendar"></app-common-icon>
            </span>
        </div>

        <label for="toDate" class="form-label">To:</label>

        <div class="position-relative" (click)="toDateInput.showPicker()">
            <input type="text" class="form-control form-control-sm" [value]="displayEndDate" readonly />
            <input type="date" [(ngModel)]="endDate" [min]="minDate" [max]="disabledDates"
                (change)="handleSelectedCustomDate()" #toDateInput class="visually-hidden-date" />
            <span class="calendar-icon input-icon">
                <app-common-icon [faIcon]="faCalendar"></app-common-icon>
            </span>
        </div>
    </div>
</div>